export default {
  text: 'Hai guadagnato {{points}} punti ({{amount}}) su questo ordine',
  button: 'Accedi e riscatta i punti',
};
